import { useState, useEffect } from 'react';

interface NavbarProps {
  onOpenBooking: () => void;
  onOpenDealer: () => void;
}

export default function Navbar({ onOpenBooking, onOpenDealer }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#05060E]/95 backdrop-blur-md border-b border-[#1A2545]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => scrollTo('hero')} className="cursor-pointer">
          <div className="px-2 py-1 rounded">
            <img
              src="https://static.readdy.ai/image/1153be8c8a2f65c98102af48ca4fb482/2911c566eae6c7f5c4dd1968245a62b6.png"
              alt="フィジオショット"
              className="h-8 md:h-9 object-contain"
            />
          </div>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: '問題提起', id: 'problem' },
            { label: 'メカニズム', id: 'solution' },
            { label: '実績', id: 'trust' },
            { label: 'ベネフィット', id: 'benefits' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium tracking-wider transition-colors cursor-pointer whitespace-nowrap text-[#D0DDF0] hover:text-[#5A9AFF]"
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={onOpenDealer}
            className="px-4 py-2 text-sm border border-[#1A2545] hover:border-[#1E6BFF] text-[#D0DDF0] hover:text-[#5A9AFF] rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            導入相談
          </button>
          <button
            onClick={onOpenBooking}
            className="px-5 py-2 text-sm bg-gradient-to-b from-[#2A7FFF] to-[#0D4FCC] hover:from-[#3D8FFF] hover:to-[#1A5FDD] text-white font-bold rounded-md transition-all cursor-pointer whitespace-nowrap shadow-[0_0_15px_rgba(30,107,255,0.4)] border-t border-[#5A9AFF]/30"
          >
            施術予約
          </button>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer text-[#D0DDF0]"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#05060E] border-t border-[#1A2545] px-6 py-4 flex flex-col gap-3">
          {[
            { label: '問題提起', id: 'problem' },
            { label: 'メカニズム', id: 'solution' },
            { label: '実績', id: 'trust' },
            { label: 'ベネフィット', id: 'benefits' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-[#D0DDF0] text-sm py-2 text-left cursor-pointer border-b border-[#1A2545] last:border-0 hover:text-[#5A9AFF]"
            >
              {item.label}
            </button>
          ))}
          <div className="flex flex-col gap-2 pt-2">
            <button
              onClick={() => { onOpenBooking(); setMenuOpen(false); }}
              className="px-5 py-3 bg-gradient-to-b from-[#2A7FFF] to-[#0D4FCC] text-white font-bold rounded-md text-sm cursor-pointer whitespace-nowrap shadow-[0_0_15px_rgba(30,107,255,0.4)]"
            >
              施術予約
            </button>
            <button
              onClick={() => { onOpenDealer(); setMenuOpen(false); }}
              className="px-5 py-3 border border-[#1A2545] text-[#D0DDF0] rounded-md text-sm cursor-pointer whitespace-nowrap"
            >
              導入相談
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
